<div class="min-h-screen bg-zinc-950 from-blue-50 to-indigo-100 flex items-center justify-center px-6 py-12 lg:px-8">
    <div class="xl:mx-auto xl:w-full 2xl:max-w-xl bg-white shadow-xl rounded-2xl p-8 max-w-md w-full transform transition-all duration-300 hover:scale-105">
      
      <!-- Logo and Header -->
      <div class="text-center mb-8">
        <div class="flex justify-center mb-4">
          <img class="h-16 w-auto transform hover:scale-110 transition-transform duration-200" src="logo.png" alt="Circle Logo">
        </div>
        <h2 class="text-3xl font-bold text-gray-900 mb-2">Welcome Back</h2>
        <p class="text-gray-600">Sign in to your 
            <span class="text-zinc-950 font-bold">Circle+ Admin</span> account</p>
      </div>
  
      <!-- Login Form -->
      <form class="space-y-6" [formGroup]="loginForm" (ngSubmit)="loginForm.valid && loginUser()">
        
        <!-- Phone/Email Field -->
        <div>
          <label for="auth" class="block text-sm font-semibold text-gray-700 mb-2">
            Phone / Email address
          </label>
          <div class="relative">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
              </svg>
            </div>
            <input 
              id="auth" 
              type="text" 
              formControlName="phone" 
              required 
              class="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 text-gray-900 placeholder-gray-400"
              placeholder="Enter your phone or email"
              [class.border-red-500]="loginForm.get('phone')?.invalid && loginForm.get('phone')?.touched"
            >
          </div>
          <div *ngIf="loginForm.get('phone')?.invalid && loginForm.get('phone')?.touched" class="mt-1 text-sm text-red-600">
            Please enter a valid phone number or email address
          </div>
        </div>
  
        <!-- Password Field -->
        <div>
          <div class="flex items-center justify-between mb-2">
            <label for="password" class="block text-sm font-semibold text-gray-700">Password</label>
            <div class="text-sm">
              <a href="#" class="font-medium text-zinc-950 hover:text-blue-500 transition-colors duration-200">Forgot password?</a>
            </div>
          </div>
          <div class="relative">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
              </svg>
            </div>
            <input 
              id="password" 
              name="password" 
              formControlName="password" 
              type="password"  
              required 
              class="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 text-gray-900 placeholder-gray-400"
              placeholder="Enter your password"
              [class.border-red-500]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
            >
          </div>
          <div *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched" class="mt-1 text-sm text-red-600">
            Password is required
          </div>
        </div>
  
        <!-- Submit Button -->
        <div>
          <button 
            type="submit" 
            [disabled]="loginForm.invalid || isLoading"
            class="flex w-full justify-center items-center rounded-lg bg-zinc-950 px-4 py-3 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 transform hover:scale-105"
          >
            <svg *ngIf="isLoading" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            {{ isLoading ? 'Signing in...' : 'Sign in' }}
          </button>
        </div>
  
        <!-- Error Message -->
        <div *ngIf="errorMessage" class="bg-red-50 border border-red-200 rounded-lg p-4">
          <div class="flex">
            <svg class="h-5 w-5 text-red-400" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
            </svg>
            <div class="ml-3">
              <p class="text-sm text-red-800">{{ errorMessage }}</p>
            </div>
          </div>
        </div>
      </form>
  
      <!-- Footer Links -->
      <div class="mt-8 pt-6 border-t border-gray-200">
        <p class="text-center text-sm text-gray-600">
          By signing in, you agree to our
          <a [routerLink]="['/termcondition']" class="font-medium text-zinc-950 hover:text-blue-500 transition-colors duration-200">Terms & Conditions</a> 
          and 
          <a [routerLink]="['/privacypolicy']" class="font-medium text-zinc-950 hover:text-blue-500 transition-colors duration-200">Privacy Policy</a>
        </p>
      </div>
    </div>
  </div>
    
    